<template>
  <section class="profile" id="add-chatbot" @click="handleClick">
    <PlusOutlined class="profile__icon" />

    <p class="profile__description">Agregar nuevo chatbot</p>
  </section>
</template>

<script>
import { PlusOutlined } from "@ant-design/icons-vue";
import { defineComponent } from "vue";
export default defineComponent({
  components: {
    PlusOutlined,
  },
  setup(_, { emit }) {
    const handleClick = () => {
      emit("click");
    };

    return {
      handleClick,
    };
  },
});
</script>

<style lang="sass" scoped>
.profile
  height: 210px
  width: 100%
  background: $blue-1
  border-radius: 4px
  border: 1.5px dashed $blue-6
  cursor: pointer

  &__icon
    margin: 66px auto 8px
    display: block
    color: $blue-6
    font-size: 40px

  &__description
    text-align: center
    color: $blue-6
</style>
